import React from 'react';

const icon1 = () => {
    return (
        <>
            <svg
                    width="51"
                    height="50"
                    viewBox="0 0 51 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M25.6995 45.8334C37.2055 45.8334 46.5329 36.506 46.5329 25C46.5329 13.4941 37.2055 4.16669 25.6995 4.16669C14.1936 4.16669 4.86621 13.4941 4.86621 25C4.86621 36.506 14.1936 45.8334 25.6995 45.8334Z"
                      stroke="white"
                      strokeWidth="4.16667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M17.3656 25C17.3656 36.506 21.0965 45.8334 25.6989 45.8334C30.3013 45.8334 34.0322 36.506 34.0322 25C34.0322 13.4941 30.3013 4.16669 25.6989 4.16669C21.0965 4.16669 17.3656 13.4941 17.3656 25Z"
                      stroke="white"
                      strokeWidth="4.16667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.86621 25H46.5329"
                      stroke="white"
                      strokeWidth="4.16667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
        </>
    );
};

export default icon1;